import { graphql } from "./generated/index.js"

// The catalog in one operation: every schema, every type, the staff directory
// (unless the host supplies its own), and the two values that say which version of the
// catalog this is. Hasura runs a query's root fields as one SQL statement, so
// the rows and their status are one snapshot.
//
// A type carries its default schema as `schema_id` only; the catalog resolves
// `type.schema` against the schemas it already holds.
export const fetchCatalog = graphql(`
  query fetchCatalog($withUsers: Boolean!) {
    schemas(order_by: { name: asc }) {
      ...SchemaFields
    }
    types(order_by: { position: asc }) {
      ...TypeFields
    }
    # The staff directory (directory.ts): the people of the staff list and the
    # partners list's members. The slugs are STAFF_LIST_SLUG and
    # PARTNERS_LIST_SLUG.
    directory_staff: record_listings(
      where: { list: { slug: { _eq: "heavybit-employees" }, type: { _eq: "list" } } }
    ) @include(if: $withUsers) {
      record {
        id
        name
        slug
        contacts(
          where: { contact_type: { _eq: "email" } }
          order_by: [{ is_primary: desc }, { position: asc }]
          limit: 1
        ) {
          value
        }
      }
    }
    directory_partners: record_listings(
      where: { list: { slug: { _eq: "heavybit-partners" }, type: { _eq: "list" } } }
    ) @include(if: $withUsers) {
      record_id
    }
    schemas_aggregate {
      aggregate {
        count
        max {
          updated_at
        }
      }
    }
    types_aggregate {
      aggregate {
        max {
          updated_at
        }
      }
    }
  }
`)

// The catalog's status alone: `last_updated` moves on any schema or type
// insert/update (both tables keep `updated_at` by trigger); `schema_count`
// moves on a schema delete. Types are never deleted.
export const fetchCatalogStatus = graphql(`
  query fetchCatalogStatus {
    schemas_aggregate {
      aggregate {
        count
        max {
          updated_at
        }
      }
    }
    types_aggregate {
      aggregate {
        max {
          updated_at
        }
      }
    }
  }
`)
